export default __webpack_public_path__ + "img/689c36cae4ca4ade1000c4c44b05f113.png";